module.exports = require('./helpers/bundle-url').getBundleURL('8B7sB') + "logo-dark.ba5147f0.svg";